import { ColumnFilter } from './ColumnFilter';

function dateFormat(value) {
	let objectDate = new Date(value);
	let day = ("0" + (objectDate.getDate())).slice(-2);
	let month = ("0" + (objectDate.getMonth() + 1)).slice(-2);
	let year = objectDate.getFullYear();

	return day + "/" + month + "/" + year;
}

export const COLUMNS = [
	{
		Header: 'اسم المورد',
		Footer: 'Supplier ID',
		accessor: 'supplier.SupplierName',
		Filter: ColumnFilter,
		// Here we don't need date formatting, SupplierID is usually numeric or text.
	},
	{
		Header: 'تاريح الطلبية',
		Footer: 'Order Date',
		accessor: 'OrderDate',
		Filter: ColumnFilter,
		// Format date using the dateFormat function
 	},
	{
		Header: 'رقم الفاتورة',
		Footer: 'رقم الفاتورة',
		accessor: 'InvoiceNumber',
		Filter: ColumnFilter,
		// Format date using the dateFormat function
 	},
	{
		Header: 'القيمة الكلية',
		Footer: 'القيمة الكلية',
		accessor: 'TotalAmount',
		Filter: ColumnFilter,
		// Assuming currency format here
 	},
	 {
		Header: 'الباقي',
		Footer: 'الباقي',
		accessor: 'ReastAmount',
		Filter: ColumnFilter,
		// Assuming currency format here
 	},
	{
		Header: 'الحالة',
		Footer: 'Status',
		accessor: 'Status',
		Filter: ColumnFilter,
	},
	
];
